import React, { Component, PropTypes as pt } from 'react';
import ReactQuill from 'react-quill';
import FaPencil from 'react-icons/lib/fa/pencil';

import Modal from '../../../common/components/Modal';
import withQuillUtils from '../../../hocs/QuillToolbarHoc';

const toolbar = {
    modules: {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link'],
        ['clean']
      ],
    },

    formats: [
      'header',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image'
    ],
};


class LegalInput extends Component {
    constructor (props) {
        super(props);

        this.state = {
            value: props.value,
            edited: false,
            modalActive: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.renderNotice = this.renderNotice.bind(this);
        this.getPreference = this.getPreference.bind(this);
        this.renderModal = this.renderModal.bind(this);
        this.cancelAndRevert = this.cancelAndRevert.bind(this);
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    handleChange (value) {
        this.setState({
            value: value,
            edited: true
        });

        this.props.storeEdits(value);
    }

    toggleModal (ev) {
        ev && ev.preventDefault && ev.preventDefault();
        this.setState({
            edited: true,
            modalActive: !this.state.modalActive
        });
    }

    cancelAndRevert () {
        this.setState({
            edited: false,
            value: this.props.value,
            modalActive: false
        });
    }

    getPreference () {
        return (this.state.edited) ? this.state.value : this.props.value;
    }

    render () {

        return (<div id="legal">
            <button className="btn btn-default" onClick={this.toggleModal}>
                <FaPencil/> Edit Legal Notice
            </button>

            {this.renderModal()}

            <blockquote>{this.renderNotice()}</blockquote>
        </div>);
    }

    renderNotice () {
        if (!this.state.modalActive) {
            const pref = this.getPreference();
            if (!pref) return (<em>No Legal Notice Set.</em>);
            return (<p dangerouslySetInnerHTML={{__html: pref}}/>);
        }
    }

    renderModal () {
        if (this.state.modalActive) {
            const pref = this.getPreference();
            return (<Modal
                cancelModal={this.toggleModal}
                saveAction={<button className="btn btn-success" onClick={this.toggleModal}>
                    <i className="fa fa-check"/> Done Editing
                </button>}>
                <Modal.Header>
                    Edit Legal Notice
                </Modal.Header>
                <Modal.Body>
                    <ReactQuill theme="snow"
                        name="legal"
                        value={pref}
                        modules={toolbar.modules}
                        formats={toolbar.formats}
                        onChange={this.handleChange}>
                    </ReactQuill>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>)
        }
    }
}

LegalInput.propTypes = {};

const LegalInputWithQuillUtils = withQuillUtils(
    LegalInput
);

export default LegalInputWithQuillUtils;
